<script setup lang="ts">
import FormBanner from '../components/form-banner.vue'
import { useBannerStore } from '../store/useBannerStore'

definePage({
  meta: {
    navActiveLink: 'banner',
    action: 'create',
    subject: 'banner',
  },
})

const { resetForm } = useBannerStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormBanner />
</template>
